var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerSalvadorCaetanoOffline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 205.46,
    height: 323,
    viewBox: "0 0 205.46 323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1560.78,
    y1: 6954.54,
    x2: -1548.23,
    y2: 6928.12,
    gradientTransform: "matrix(-0.72, 0.69, 0.69, 0.72, -5803.55, -3851.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4914.66,
    y1: 5738.94,
    x2: -4882.74,
    y2: 5692.83,
    gradientTransform: "matrix(-0.97, -0.22, -0.22, 0.97, -3344.33, -6562.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5758,
    y1: 2662.48,
    x2: -5730.85,
    y2: 2651.62,
    gradientTransform: "matrix(-0.45, -0.89, -0.89, 0.45, -63.03, -6178.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3604.74,
    y1: -113.77,
    x2: -3579.61,
    y2: -160.75,
    gradientTransform: "matrix(0.5, -0.86, -0.86, -0.5, 1787.58, -3020.31)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 56.43,
    y1: 209.87,
    x2: 31.49,
    y2: 221.09,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 323)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 77.47,
    y1: 299.66,
    x2: 72.43,
    y2: 243.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 323)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "goCharge_marker_offline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205.46,102.73a102.73,102.73,0,1,0-191,52.56h-.07L102.73,323l88.34-167.71H191A102.21,102.21,0,0,0,205.46,102.73Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.22,45.67a55.49,55.49,0,0,1,45.6,41.82c5.17-1.81,10.31-3.6,15.44-5.33a71.83,71.83,0,0,0-58.48-52.57,8.14,8.14,0,0,0-9.34,7.92h0A8.06,8.06,0,0,0,110.22,45.67Z",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.44,131.27c-1.34-4.31.91-9.9,6.77-9.9,7.51,0,9.09,9.17,4.78,13.07a8.92,8.92,0,0,1,.29,1.24,71.72,71.72,0,0,0,2.94-64.91,8.14,8.14,0,0,0-11.73-3.5h0a8.05,8.05,0,0,0-3.13,10.13A55.51,55.51,0,0,1,145,135.26a8.42,8.42,0,0,1,1.63-.16,7.31,7.31,0,0,1,3.53.86A7.26,7.26,0,0,1,152.44,131.27Z",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.85,124.43a55.48,55.48,0,0,1-53.56,31q.27,8.21.46,16.33a71.83,71.83,0,0,0,67.67-40.06,8.13,8.13,0,0,0-4.76-11.28h0A8.07,8.07,0,0,0,151.85,124.43Z",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109,155.12a55.46,55.46,0,0,1-55.19-28c-4.49,3.13-9,6.25-13.43,9.3a71.82,71.82,0,0,0,70.5,34.83,8.13,8.13,0,0,0,6.85-10.14h0A8,8,0,0,0,109,155.12Z",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.52,131.58a55.46,55.46,0,0,1-4.45-54.91,6.55,6.55,0,0,1-1-.47,6.79,6.79,0,0,1-6.93,5.52c-6.46,0-8.53-6.79-6.24-11.17a6.52,6.52,0,0,1-.53-.87,71.81,71.81,0,0,0,5.66,71,8.15,8.15,0,0,0,12.16,1.42h0A8.09,8.09,0,0,0,56.52,131.58Z",
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.66,21.16h-.36a8,8,0,0,0-8,7.89A71.82,71.82,0,0,0,36,72.8a8.14,8.14,0,0,0,5.45,11h0A8.06,8.06,0,0,0,51,79.13,55.48,55.48,0,0,1,94.34,45.44V70.57a8,8,0,0,0,8,8h.36a8,8,0,0,0,8-8V29.11A8,8,0,0,0,102.66,21.16Z",
    fill: "url(#linear-gradient-6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerSalvadorCaetanoOffline);
export default __webpack_public_path__ + "static/media/marker_salvadorCaetano_offline.e55b57e987d6483b8920ccc024621199.svg";
export { ForwardRef as ReactComponent };